import React, { useEffect, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './Input.module.css';
import { SettingsFeatureLock } from '../../LockedFeatures/SettingsFeatureLock';

const Input = ({
    id,
    value,
    changed,
    blurred,
    error,
    notification,
    disabled,
    color,
    placeholder,
    style,
    minNumber,
    maxNumber,
    tooltip = '',
    type = 'text',
    rows = 1,
    allowShowPassword = true,
    displayError = true,
    displayNotifications = true,
    maxLength,
    inputId,
    maxWidth,
    inputStyle = {},
    errorStyle = {},
    featureLockId = undefined,
    featureLockIsTabId = undefined
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const [textVal, setTextVal] = useState(value);
    useEffect(() => {
        setTextVal((txVal) => {
            if (
                typeof value === 'string' &&
                txVal &&
                value.trim() === txVal.trim() &&
                type !== 'password' &&
                type !== 'textarea'
            ) {
                return txVal;
            }
            return value;
        });
    }, [value, type]);

    const onValChange = (e) => {
        let returnTextVal = e.target.value;
        if (type === 'number' && returnTextVal) {
            if (maxNumber && parseInt(returnTextVal) > parseInt(maxNumber)) {
                returnTextVal = maxNumber;
            }
            if (minNumber && parseInt(returnTextVal) < parseInt(minNumber)) {
                returnTextVal = minNumber;
            }
        }
        if (type !== 'password' && type !== 'textarea') {
            setTextVal(returnTextVal.trimStart());
            returnTextVal = returnTextVal.trim();
        } else {
            setTextVal(returnTextVal);
        }

        changed(id, returnTextVal);
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const inputStyles = [styles.input];
    if (color === 'grey') {
        inputStyles.push(styles.grey);
    }
    if (color === 'red') {
        inputStyles.push(styles.red);
    }
    if (error) {
        inputStyles.push(styles.error);
    }

    if (type === 'password') {
        inputStyles.push(styles.passwordInput);
    }

    let inputType = type;
    if (type === 'password' && showPassword) {
        inputType = 'text';
    }

    let input = null;
    if (inputType === 'textarea') {
        input = (
            <textarea
                id={inputId ? inputId : ''}
                type={inputType}
                className={inputStyles.join(' ')}
                placeholder={placeholder}
                rows={rows}
                value={textVal}
                disabled={disabled}
                onChange={onValChange}
                onBlur={blurred}
                style={inputStyle}
            />
        );
    } else {
        input = (
            <input
                id={inputId ? inputId : ''}
                type={inputType}
                className={inputStyles.join(' ')}
                placeholder={placeholder}
                value={textVal || ''}
                disabled={disabled}
                onChange={onValChange}
                min={minNumber}
                max={maxNumber}
                maxLength={maxLength}
            />
        );
    }

    if (featureLockId) {
        input = (
            <SettingsFeatureLock id={featureLockId} isTabId={!!featureLockIsTabId} className="w-full">
                {input}
            </SettingsFeatureLock>
        );
    }

    const getPasswordIcon = () => {
        let passwordIcon = null;
        if (type === 'password' && value && allowShowPassword) {
            passwordIcon = (
                <i
                    className={`${styles.showPasswordButton} fa + ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                    onClick={toggleShowPassword}></i>
            );
            if (featureLockId) {
                passwordIcon = (
                    <SettingsFeatureLock
                        id={featureLockId}
                        isTabId={!!featureLockIsTabId}
                        className="flex items-center">
                        {passwordIcon}
                    </SettingsFeatureLock>
                );
            }
        }
        return passwordIcon;
    };
    const passwordIcon = getPasswordIcon();

    return (
        <div
            className={styles.inputContainer}
            style={style || { maxWidth: maxWidth ? maxWidth : type === 'textarea' ? '600px' : '350px' }}>
            <div className={styles.inputField}>
                <Tooltip
                    disableHoverListener={!disabled}
                    disabled={!tooltip}
                    title={tooltip}
                    arrow={true}
                    enterDelay={disabled ? 500 : 0}
                    classes={{ tooltip: 'generic-tooltip' }}>
                    {input}
                </Tooltip>
                {passwordIcon}
            </div>
            {error && displayError && (
                <div className={styles.errorText} style={errorStyle}>
                    {error}
                </div>
            )}
            {notification && displayNotifications && <div className={styles.notificationText}>{notification}</div>}
        </div>
    );
};

export default React.memo(Input);
